const PARAGRAPH_PODCAST = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
    ... on PodcastParagraph {
      id
      bottomSeparator
      button {
        title
        url
      }
      heading
      icon
      titleOne
      titleTwo
      uuid
      type
      series {
        title
        allAffiliates
        author
        bodyListing
        bundle
        categories {
          alias
          color
          name
          weight
        }
        memberOnly
        nid
        pathAlias
        publishedOn
        sidebarBoxes
        statusCode
        statusMessages
        summary
        featuredImage {
          alt
          animatedGif
          ctaBlockLogo
          ctaIconBlockLandscape
          ctaIconBlockSquare
          description
          downloadable
          horizontalCardImage
          latestEpisodeImage
          newsFeaturedImage
          podcastEpisodeImage
          promotionBlockLandscape
          promotionBlockLandscapeMedium
          responsiveImage
          smallPromotionBlockLandscape
          title
          twitterImage
          type
          url
          verticalCardImage
          video_16_9
        }
      }
      latest {
        nid
        author
        bodyListing
        bundle
        memberOnly
        pathAlias
        publishedOn
        sidebarBoxes
        statusCode
        statusMessages
        summary
        summaryListing
        title
        allAffiliates
        categories {
          alias
          color
          name
          weight
        }
        featuredImage {
          alt
          animatedGif
          ctaBlockLogo
          ctaIconBlockLandscape
          ctaIconBlockSquare
          description
          downloadable
          horizontalCardImage
          latestEpisodeImage
          newsFeaturedImage
          podcastEpisodeImage
          promotionBlockLandscape
          promotionBlockLandscapeMedium
          responsiveImage
          smallPromotionBlockLandscape
          title
          twitterImage
          type
          url
          verticalCardImage
          video_16_9
        }
        ... on Podcast {
          summary
          series {
            title
          }
        }
        boxesBottom
      }
    }
  }
`;

export default PARAGRAPH_PODCAST;
